import { render, staticRenderFns } from "./AdContentList.vue?vue&type=template&id=63c67e4a&scoped=true&"
import script from "./AdContentList.vue?vue&type=script&lang=js&"
export * from "./AdContentList.vue?vue&type=script&lang=js&"
import style0 from "./AdContentList.vue?vue&type=style&index=0&id=63c67e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c67e4a",
  null
  
)

export default component.exports